import { Icon } from '@iconify/react/dist/iconify.js'
import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useState } from 'react'
import api from '../../services/api'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { Modal, Button, Spinner } from 'react-bootstrap';

const ForgotPasswordLayer = () => {
    const [formData, setFormData] = useState({

        email: '',
        password: '',
        password_confirmation: ''

    });
    const [error, setError] = useState('');
    const [showOtpModal, setShowOtpModal] = useState(false);
    const [showResetModal, setShowResetModal] = useState(false);
    const [otp, setOtp] = useState('');
    const [otpTimer, setOtpTimer] = useState(60); // Timer in seconds
    const [password, setPassword] = useState('');
    const [passwordC, setPasswordC] = useState('');
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };
    const handleForget = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        try {

            await api.post('/auth/forgetPassword', { email: formData.email });
            setShowOtpModal(true); // Show OTP Modal

        } catch (err) {
            setError(err.response?.data?.message || 'An error occurred');
        }
        setLoading(false);
    };

    // Handle OTP Verification
    const handleVerifyOtp = async () => {
        setLoading(true);
        try {
            const response = await api.post('/otp/verifyOtp', { email: formData.email, otp });
            if (response.data.status) {
                setShowOtpModal(false);
                setShowResetModal(true);
            } else {
                setError('Invalid OTP');
            }
        } catch (err) {
            setError('Error verifying OTP');
        }
        setLoading(false);
    };
    const handleReset = async () => {
        setLoading(true);
        try {
            const response = await api.post('/auth/resetPassword', { email: formData.email, password: formData.password, password_confirmation: formData.password_confirmation });
            if (response.data.status) {
                toast.success("Password reset successfully! Sign in with your new password.")
                navigate('/sign-in');
            } else {
                toast.error("Error")
                setError('Error');
            }
        } catch (err) {
            setError('Error');
        }
        setLoading(false);
    };
    // OTP Timer Effect
    useEffect(() => {
        let timerInterval;
        if (showOtpModal && otpTimer > 0) {
            timerInterval = setInterval(() => {
                setOtpTimer((prev) => (prev > 0 ? prev - 1 : prev));
            }, 1000);
        }
        return () => clearInterval(timerInterval);
    }, [showOtpModal, otpTimer]);

    // Handle Resend OTP
    const handleResendOtp = async () => {
        setLoading(true);
        try {
            await api.post('/auth/forgetPassword', { email: formData.email });
            toast.success('OTP Resent Successfully!');
            setOtpTimer(60);
        } catch (error) {
            toast.error('Failed to resend OTP');
        }
        setLoading(false);
    };
    return (
        <>
            <section className="auth forgot-password-page bg-base d-flex flex-wrap">
                <div className="auth-left d-lg-block d-none">
                    <img
                        src="assets/images/auth/2.jpg"
                        alt=""
                        style={{ width: "100%", height: "100%", objectFit: "cover" }}
                    />
                </div>
                <div className="auth-right py-32 px-24 d-flex flex-column justify-content-center">
                    <div className="max-w-464-px mx-auto w-100">
                        <div>
                            <Link to="/" className="mb-40 max-w-290-px">
                                {/* <img src="assets/images/logo.png" alt="" /> */}
                                <h3>Brokerz</h3>
                            </Link>
                            <h6 className="mb-12">Forgot Password</h6>
                            <p className="mb-32 text-secondary-light text-m">
                                Enter the email address associated with your account and we will
                                send you a otp to reset your password.
                            </p>
                        </div>
                        {error && <div className="text-danger mb-16">{error}</div>}
                        <form onSubmit={handleForget}>
                            <div className="icon-field">
                                <span className="icon top-50 translate-middle-y">
                                    <Icon icon="mage:email" />
                                </span>
                                <input
                                    type="email"
                                    name='email'
                                    className="form-control h-56-px bg-neutral-50 radius-12"
                                    value={formData.email}
                                    onChange={handleInputChange}
                                    required
                                    placeholder="Enter Email"
                                />
                            </div>
                            <button
                                type="submit"
                                className="btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32"
                                disabled={loading}
                            >
                                {loading ? <Spinner animation="border" size="sm" /> : 'Continue'}
                            </button>
                            <div className="text-center">
                                <Link to="/sign-in" className="text-primary-600 fw-bold mt-24">
                                    Back to Sign In
                                </Link>
                            </div>
                            <div className="mt-120 text-center text-sm">
                                <p className="mb-0">
                                    Already have an account?{" "}
                                    <Link to="/sign-in" className="text-primary-600 fw-semibold">
                                        Sign In
                                    </Link>
                                </p>
                            </div>
                        </form>
                    </div>
                </div>
            </section>
            <Modal
                show={showOtpModal}
                onHide={() => setShowOtpModal(false)}
                centered
                backdrop="static"
                className="transparent-modal" // Use this class to add custom transparent styles if desired
            >
                <Modal.Header closeButton>
                    <Modal.Title>Verify your Email</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className="text-secondary-light text-sm mb-16">
                        ✅ If your email is registered, you will receive an OTP shortly. Enter it below:
                    </p>
                    <input
                        type="text"
                        placeholder="Enter OTP"
                        value={otp}
                        onChange={(e) => setOtp(e.target.value)}
                        className="form-control h-56-px bg-neutral-50 radius-12 mb-16"
                    />
                    <div className="d-flex justify-content-between align-items-center">
                        {otpTimer > 0 ? (
                            <span>Resend OTP in {otpTimer} seconds</span>
                        ) : (
                            <button onClick={handleResendOtp} className="btn btn-link" disabled={loading}>
                                {loading ? <Spinner animation="border" size="sm" /> : 'Resend OTP'}
                            </button>
                        )}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleVerifyOtp} variant="primary" disabled={loading}>
                        {loading ? <Spinner animation="border" size="sm" /> : 'Verify OTP'}
                    </Button>
                </Modal.Footer>
            </Modal>
            {/* Reset Password Modal */}
            {showResetModal && (
                <div className="modal fade show d-block" tabIndex="-1" role="dialog">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content radius-16 bg-base">
                            <div className="modal-body p-40 text-center">
                                <h6 className="mb-12">Reset Your Password</h6>
                                <p className="text-secondary-light text-sm mb-16">
                                    Enter your new password below:
                                </p>
                                <input
                                    type="password"
                                    name="password"
                                    placeholder="Password"
                                    value={formData.password}
                                    onChange={handleInputChange}
                                    className="form-control h-56-px bg-neutral-50 radius-12 mb-16"
                                />
                                <input
                                    type="password"
                                    name="password_confirmation"
                                    placeholder="Password Confirmation"
                                    value={formData.password_confirmation}
                                    onChange={handleInputChange}
                                    className="form-control h-56-px bg-neutral-50 radius-12 mb-16"
                                />
                                <span className="text-sm text-secondary-light fst-italic">
                                    Password should contain at least one uppercase, one number, and one special character and minimum 8 characters
                                </span>
                                <br></br>
                                <button
                                    onClick={handleReset}
                                    className="btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12"
                                    disabled={loading}
                                >
                                    {loading ? <Spinner animation="border" size="sm" /> : 'Reset Password'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </>

    )
}

export default ForgotPasswordLayer